/** @jsx jsx */
import * as React from 'react';
import { jsx } from "@emotion/core";
import * as styles from './style';

interface IPaginatorProps {
    itemsPerPage?: number,
    onMoveForward: () => void,
    onMoveBackward: () => void,
    totalItemCount: number,
}

const Paginator = (props: IPaginatorProps) => {

    const { itemsPerPage, totalItemCount, onMoveBackward, onMoveForward } = props;
    const [pageParams, setPageParams] = React.useState({ currPage: 0, maxPageSize: 1 });
    const ITEMS_PER_PAGE = itemsPerPage || 10;

    React.useEffect(() => {
        setPageParams({
            currPage: 0,
            maxPageSize: Math.ceil(totalItemCount / ITEMS_PER_PAGE),
        });
    }, [])


    const moveForward = () => {
        const moveToPage = pageParams.currPage + 1
        if (moveToPage < pageParams.maxPageSize) {
            setPageParams({ ...pageParams, currPage: moveToPage })
            onMoveForward();
        }
    }

    const moveBackward = () => {
        const moveToPage = pageParams.currPage - 1
        if (moveToPage >= 0) {
            setPageParams({ ...pageParams, currPage: moveToPage })
            onMoveBackward();
        }
    }

    const calcStartIndex = () => pageParams.currPage * ITEMS_PER_PAGE + 1;
    const calcEndIndex = () => Math.min((pageParams.currPage + 1) * ITEMS_PER_PAGE, totalItemCount);

    return totalItemCount > 0 ? <div css={styles.paginator}>
        <span css={styles.prevButton} onClick={moveBackward}>
            <img src="/images/icons/left-arrow-red.svg" />
            <span>Previous</span>
        </span>
        <span>{`${calcStartIndex()}-${calcEndIndex()} of ${totalItemCount}`}</span>
        <span css={styles.nextButton} onClick={moveForward} >
            <span>Next</span>
            <img src="/images/icons/right-arrow-red.svg" />
        </span>
    </div> : null;


}

export default Paginator
